import { ModelBase } from "./ModelBase"

export class ImportFattureElettronicaModel extends ModelBase {
    Files: Array<File>
    Inizio: string
    Fine: string
}
